/**
 * created by Alex on 9/11/2020.
 * Description:
 *
 * ------ maintenance history ------
 */
export class AutoTaggingModel {
    modelName: string;
    noteTypes: string;
    number: number;
    script: string;
    constructor(modelName: string = '', noteTypes: string = '', number: number = 200, script: string = '') {
        this.modelName = modelName;
        this.noteTypes = noteTypes;
        this.number = number;
        this.script = script;
    }
}
